module.exports = __webpack_public_path__ + "static/unlock-36a1016725072e57d74f92c98cede75b.svg";